import React from 'react';
import type { IconProps } from '../types';

export const LayoutAdvanced3DFourUp = (props: IconProps) => (
  <svg
    width="29px"
    height="18px"
    viewBox="0 0 29 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-advanced-3d-four-up"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="27"
          height="16.2"
          rx="2"
        ></rect>
        <path
          d="M0,0 L11.8857143,-2.22044605e-16 C12.9902838,5.56104062e-16 13.8857143,0.8954305 13.8857143,2 L13.8857143,14.2 C13.8857143,15.3045695 12.9902838,16.2 11.8857143,16.2 L0,16.2 L0,16.2 L0,0 Z"
          id="Rectangle"
          transform="translate(6.9429, 8.1) scale(-1, 1) translate(-6.9429, -8.1)"
        ></path>
        <path
          d="M13.8857143,0 L25,0 C26.1045695,-1.18396092e-15 27,0.8954305 27,2 L27,8.5 L27,8.5 L13.8857143,8.5 L13.8857143,0 Z"
          id="Rectangle"
          fill="#263A71"
        ></path>
        <path
          d="M0,8.48571429 L13.8857143,8.48571429 L13.8857143,14.2 C13.8857143,15.3045695 12.9902838,16.2 11.8857143,16.2 L0,16.2 L0,16.2 L0,8.48571429 Z"
          id="Rectangle"
          transform="translate(6.9429, 12.3429) scale(-1, 1) translate(-6.9429, -12.3429)"
        ></path>
        <path
          d="M13.8857143,8.48571429 L27,8.48571429 L27,14.2 C27,15.3045695 26.1045695,16.2 25,16.2 L13.8857143,16.2 L13.8857143,16.2 L13.8857143,8.48571429 Z"
          id="Rectangle"
        ></path>
      </g>
    </g>
  </svg>
);

export const LayoutAdvanced3DMain = (props: IconProps) => (
  <svg
    width="29px"
    height="18px"
    viewBox="0 0 29 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-advanced-3d-main"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="27"
          height="16.2"
          rx="2"
        ></rect>
        <path
          d="M18,7.71428571 L27,7.71428571 L27,14.2 C27,15.3045695 26.1045695,16.2 25,16.2 L18,16.2 L18,16.2 L18,7.71428571 Z"
          id="Rectangle"
        ></path>
        <path
          d="M0,7.71428571 L9.25714286,7.71428571 L9.25714286,16.2 L2,16.2 C0.8954305,16.2 9.55813795e-16,15.3045695 8.8817842e-16,14.2 L0,7.71428571 L0,7.71428571 Z"
          id="Rectangle"
        ></path>
        <path
          d="M2,0 L25,0 C26.1045695,-2.02906125e-16 27,0.8954305 27,2 L27,8.48571429 L27,8.48571429 L0,8.48571429 L0,2 C-1.3527075e-16,0.8954305 0.8954305,1.3527075e-16 2,0 Z"
          id="Rectangle"
          fill="#263A71"
          transform="translate(13.5, 4.2429) scale(-1, 1) translate(-13.5, -4.2429)"
        ></path>
      </g>
    </g>
  </svg>
);

export const LayoutAdvanced3DOnly = (props: IconProps) => (
  <svg
    width="29px"
    height="18px"
    viewBox="0 0 29 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-advanced-3d-only"
        transform="translate(1, 1)"
        fill="#263A71"
        stroke="currentColor"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="27"
          height="16.2"
          rx="2"
        ></rect>
      </g>
    </g>
  </svg>
);

export const LayoutAdvanced3DPrimary = (props: IconProps) => (
  <svg
    width="29px"
    height="18px"
    viewBox="0 0 29 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-advanced-3d-primary"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="27"
          height="16.2"
          rx="2"
        ></rect>
        <path
          d="M15.4285714,10.5 L27,10.5 L27,14 C27,15.1045695 26.1045695,16 25,16 L15.4285714,16 L15.4285714,16 L15.4285714,10.5 Z"
          id="Rectangle"
        ></path>
        <path
          d="M15.4285714,0 L25,0 C26.1045695,-2.02906125e-16 27,0.8954305 27,2 L27,5.4 L27,5.4 L15.4285714,5.4 L15.4285714,0 Z"
          id="Rectangle"
        ></path>
        <path
          d="M0,0 L14.2,0 C15.3045695,-2.02906125e-16 16.2,0.8954305 16.2,2 L16.2,14.2 C16.2,15.3045695 15.3045695,16.2 14.2,16.2 L0,16.2 L0,16.2 L0,0 Z"
          id="Rectangle"
          fill="#263A71"
          transform="translate(8.1, 8.1) scale(-1, 1) translate(-8.1, -8.1)"
        ></path>
      </g>
    </g>
  </svg>
);

export const LayoutAdvancedAxialPrimary = (props: IconProps) => (
  <svg
    width="29px"
    height="18px"
    viewBox="0 0 29 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-advanced-axial-primary"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <path
          d="M15.4285714,0 L25,0 C26.1045695,-2.02906125e-16 27,0.8954305 27,2 L27,14.2 C27,15.3045695 26.1045695,16.2 25,16.2 L15.4285714,16.2 L15.4285714,16.2 L15.4285714,0 Z"
          id="Rectangle"
        ></path>
        <path
          d="M15.4285714,0 L25,0 C26.1045695,-2.02906125e-16 27,0.8954305 27,2 L27,8.48571429 L27,8.48571429 L15.4285714,8.48571429 L15.4285714,0 Z"
          id="Rectangle"
        ></path>
        <path
          d="M4.54747351e-13,0 L13.7,0 C14.8045695,-2.02906125e-16 15.7,0.8954305 15.7,2 L15.7,14.2 C15.7,15.3045695 14.8045695,16.2 13.7,16.2 L4.54747351e-13,16.2 L4.54747351e-13,16.2 L4.54747351e-13,0 Z"
          id="Rectangle"
          transform="translate(7.85, 8.1) scale(-1, 1) translate(-7.85, -8.1)"
        ></path>
      </g>
    </g>
  </svg>
);

export const LayoutAdvancedMPR = (props: IconProps) => (
  <svg
    width="29px"
    height="18px"
    viewBox="0 0 29 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-advanced-mpr"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <path
          d="M17.7428571,0 L25,0 C26.1045695,-2.02906125e-16 27,0.8954305 27,2 L27,14.2 C27,15.3045695 26.1045695,16.2 25,16.2 L17.7428571,16.2 L17.7428571,16.2 L17.7428571,0 Z"
          id="Rectangle"
        ></path>
        <rect
          id="Rectangle"
          x="9"
          y="0"
          width="9"
          height="16.2"
        ></rect>
        <path
          d="M0,0 L7.25714286,0 C8.36171236,-1.18396092e-15 9.25714286,0.8954305 9.25714286,2 L9.25714286,14.2 C9.25714286,15.3045695 8.36171236,16.2 7.25714286,16.2 L0,16.2 L0,16.2 L0,0 Z"
          id="Rectangle"
          transform="translate(4.6286, 8.1) scale(-1, 1) translate(-4.6286, -8.1)"
        ></path>
      </g>
    </g>
  </svg>
);

export const LayoutCommon1x1 = (props: IconProps) => (
  <svg
    width="28px"
    height="18px"
    viewBox="0 0 28 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-common-1x1"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="26"
          height="15.6"
          rx="2"
        ></rect>
      </g>
    </g>
  </svg>
);

export const LayoutCommon1x2 = (props: IconProps) => (
  <svg
    width="28px"
    height="18px"
    viewBox="0 0 28 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-common-1x2"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="26"
          height="15.6"
          rx="2"
        ></rect>
        <path
          d="M0,0 L11,-4.4408921e-16 C12.1045695,-6.46995335e-16 13,0.8954305 13,2 L13,13.6 C13,14.7045695 12.1045695,15.6 11,15.6 L0,15.6 L0,15.6 L0,0 Z"
          id="Rectangle"
          transform="translate(6.5, 7.8) scale(-1, 1) translate(-6.5, -7.8)"
        ></path>
      </g>
    </g>
  </svg>
);

export const LayoutCommon2x1 = (props: IconProps) => (
  <svg
    width="28px"
    height="18px"
    viewBox="0 0 28 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-common-2x1"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="26"
          height="15.6"
          rx="2"
        ></rect>
        <path
          d="M2,0 L24,0 C25.1045695,-2.02906125e-16 26,0.8954305 26,2 L26,6.8 L26,6.8 L0,6.8 L0,2 C-1.3527075e-16,0.8954305 0.8954305,1.3527075e-16 2,0 Z"
          id="Rectangle"
        ></path>
      </g>
    </g>
  </svg>
);

export const LayoutCommon2x2 = (props: IconProps) => (
  <svg
    width="28px"
    height="18px"
    viewBox="0 0 28 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-common-2x2"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="26"
          height="15.6"
          rx="2"
        ></rect>
        <path
          d="M0,0 L11,-4.4408921e-16 C12.1045695,-6.46995335e-16 13,0.8954305 13,2 L13,13.6 C13,14.7045695 12.1045695,15.6 11,15.6 L0,15.6 L0,15.6 L0,0 Z"
          id="Rectangle"
          transform="translate(6.5, 7.8) scale(-1, 1) translate(-6.5, -7.8)"
        ></path>
        <path
          d="M2,0 L24,0 C25.1045695,-2.02906125e-16 26,0.8954305 26,2 L26,8 L26,8 L0,8 L0,2 C-1.3527075e-16,0.8954305 0.8954305,1.3527075e-16 2,0 Z"
          id="Rectangle"
          transform="translate(13, 4) scale(-1, 1) translate(-13, -4)"
        ></path>
      </g>
    </g>
  </svg>
);

export const LayoutCommon2x3 = (props: IconProps) => (
  <svg
    width="28px"
    height="18px"
    viewBox="0 0 28 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="Layout-select----FINAL"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="layout-common-2x3"
        transform="translate(1, 1)"
        stroke="currentColor"
      >
        <rect
          id="Rectangle"
          x="0"
          y="0"
          width="26"
          height="15.6"
          rx="2"
        ></rect>
        <path
          d="M0,0 L7,0 C8.1045695,-2.02906125e-16 9,0.8954305 9,2 L9,13.6 C9,14.7045695 8.1045695,15.6 7,15.6 L0,15.6 L0,15.6 L0,0 Z"
          id="Rectangle"
          transform="translate(4.5, 7.8) scale(-1, 1) translate(-4.5, -7.8)"
        ></path>
        <path
          d="M0,0 L15,-4.4408921e-16 C16.1045695,-6.46995335e-16 17,0.8954305 17,2 L17,13.6 C17,14.7045695 16.1045695,15.6 15,15.6 L0,15.6 L0,15.6 L0,0 Z"
          id="Rectangle"
          transform="translate(8.5, 7.8) scale(-1, 1) translate(-8.5, -7.8)"
        ></path>
        <path
          d="M2,0 L24,0 C25.1045695,-2.02906125e-16 26,0.8954305 26,2 L26,8 L26,8 L0,8 L0,2 C-1.3527075e-16,0.8954305 0.8954305,1.3527075e-16 2,0 Z"
          id="Rectangle"
          transform="translate(13, 4) scale(-1, 1) translate(-13, -4)"
        ></path>
      </g>
    </g>
  </svg>
);
